export type MonthName = { en: string; bn: string };

export default class MonthUtils {
    public MonthNameMap: Record<string, MonthName> = {
        JANUARY:   { en: "January",   bn: "জানুয়ারি" },
        FEBRUARY:  { en: "February",  bn: "ফেব্রুয়ারি" },
        MARCH:     { en: "March",     bn: "মার্চ" },
        APRIL:     { en: "April",     bn: "এপ্রিল" },
        MAY:       { en: "May",       bn: "মে" },
        JUNE:      { en: "June",      bn: "জুন" },
        JULY:      { en: "July",      bn: "জুলাই" },
        AUGUST:    { en: "August",    bn: "আগস্ট" },
        SEPTEMBER: { en: "September", bn: "সেপ্টেম্বর" },
        OCTOBER:   { en: "October",   bn: "অক্টোবর" },
        NOVEMBER:  { en: "November",  bn: "নভেম্বর" },
        DECEMBER:  { en: "December",  bn: "ডিসেম্বর" },
    };

    public formatMonths = (months: any, isBangla: boolean): string => {
        if (!months) return "";
        const arr = typeof months === "string" ? JSON.parse(months) : months;
        if (!Array.isArray(arr) || arr.length === 0) return "";
        return arr
            .map((m: string) => {
                const key = m.toUpperCase();
                return isBangla ? (this.MonthNameMap[key]?.bn || m) : (this.MonthNameMap[key]?.en || m);
            })
            .join(", ");
    };
}